export const SelectEntrada = (entradas) => {
  let precio = 0;
  let tipo = "VENTA";
  let now = new Date();

  let select = entradas.filter((e) => {
    let vencimiento_fecha = new Date(e.vencimiento_fecha + " 00:00:00");

    if (e.vencimiento_fecha == null || e.vencimiento_fecha == '0000-00-00') {
      vencimiento_fecha = new Date();
      vencimiento_fecha.setDate(vencimiento_fecha.getDate() + 1);
    }

    return e.status == "ACTIVO" && vencimiento_fecha.getTime() >= now.getTime();
  });


  if(select.length > 0){
    precio = select[0].precio;
  }

  entradas.map((entrada) => {
    let vencimiento_fecha = new Date(entrada.vencimiento_fecha + " 00:00:00");

    if (entrada.vencimiento_fecha == null) {
      vencimiento_fecha = new Date();
      vencimiento_fecha.setDate(vencimiento_fecha.getDate() + 1);
    }

    if (entrada.vencimiento_fecha == '0000-00-00') {
      vencimiento_fecha = new Date();
      vencimiento_fecha.setDate(vencimiento_fecha.getDate() + 1);
    }

    if (
      entrada.status == "ACTIVO" &&
      vencimiento_fecha.getTime() >= now.getTime()
    ) {

      if (entrada.precio <= 0) {
        tipo = entrada.tipo;
      }

      if (parseFloat(precio) > parseFloat(entrada.precio)) {
        precio = entrada.precio;
      }
    }
  });


  

  if (precio <= 0) {
    return tipo;
  }

  return `$${parseFloat(precio).toLocaleString("es-AR", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  })}`;
};

export default SelectEntrada;
